(function () {
    'use strict';

    angular
        .module('ib-seat-map-module')
        .directive('ibCalculateHeightLeyendContainer', ibCalculateHeightLeyendContainer);

    ibCalculateHeightLeyendContainer.$inject = ['$window','$timeout'];
    function ibCalculateHeightLeyendContainer ($window,$timeout) {
        return {
            restrict: 'A',
            link: link
        };
        function link (scope, element) {
            angular.element($window).on('resize', () => {
                if(angular.element('.ib-modal-with-footer__footer').length) {
                    const calcFooterHeight = angular.element('.ib-modal-with-footer__footer')[0].clientHeight;
                    angular.element(element).css('margin-bottom', calcFooterHeight + 'px');
                }

            });
            $timeout(()=>  {
                angular.element($window).triggerHandler('resize');
            },1000);
        }
    }
})();
